export default __webpack_public_path__ + "static/media/tickets-distributeur-empty-icon.723111c4.svg";